// extracted by mini-css-extract-plugin
export default {"gridClass":"viewMembers_gridClass__jbufm","chipClass":"viewMembers_chipClass__4bW1w"};